import { render } from "./Info.vue?vue&type=template&id=4bd89500"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Source\\平台项目\\YUNCar\\Source\\Delivery.Mobile.UI\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__